import React from 'react';
import styled from 'styled-components';
import SymbolFormat from './SymbolFormat';
import { toSlug } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_CTA, DATA_TRACK_CLICK_BANNER_SECTION } from '../../../../lib/constants';
import Button from '../Button/Button';

const BannerContainer = styled.div`
  background-color: ${({ theme }) => theme.c.bg['feature-1']};
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${(p) => p.theme.breakpoint.mobile}px) {
    .content-section--banner {
      h2 {
        text-align: center;
      }
    }
  }

  .content-section--banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: ${({ theme }) => theme.c.text.primary};
      ${({ theme }) => theme.typographyRebrand.heading['2xl']}
      margin-bottom: 24px;
    }
  }
`;

const BannerSection = (props) => {
  const {
    title,
    buttonUrl,
    buttonText,
    linkTarget,
  } = props;

  return (
    <BannerContainer>
      <div className="content-section content-section--banner">
        <SymbolFormat elementTag="h2" text={title} />
        <Button
          variant="primary"
          theme="light"
          size="medium"
          url={buttonUrl}
          buttonText={buttonText}
          target={linkTarget}
          data-track-id={toSlug(buttonText)}
          data-track-click={DATA_TRACK_CLICK_BANNER_SECTION}
          data-track-type={DATA_TRACK_TYPE_CTA}
        />
      </div>
    </BannerContainer>
  );
};

export default BannerSection;
